import { render, staticRenderFns } from "./Winter.vue?vue&type=template&id=070c82a8&scoped=true"
import script from "./Winter.vue?vue&type=script&lang=js"
export * from "./Winter.vue?vue&type=script&lang=js"
import style0 from "./Winter.vue?vue&type=style&index=0&id=070c82a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070c82a8",
  null
  
)

export default component.exports